<form class="card mt-2" *ngIf="canEdit">
  <div class="card-body">
    <div class="float-right">
      <button type="button" routerLink="/queues/form-approval" class="btn btn-secondary mr-2">
        Form Approval
        <span *ngIf="formApprovalCount>0" class="badge badge-danger" style="vertical-align: inherit;">{{formApprovalCount}}</span>
      </button>
      <button *ngIf="canEdit" type="button" routerLink="/uploaddocs/vaccine-list" class="btn btn-secondary">Uploaded Vaccine Information</button>
    </div>
      <h2 class="mb-3">Documents Upload Approval</h2>

    <i *ngIf="loadingUploadDocsApprovalList" class="material-icons rotate text-muted">loop</i>
    <p-table #myTable [value]="uploadDocsApprovalList" [responsive]="true"
    [paginator]="true" [rows]="20"  [lazy]="false">
        <ng-template pTemplate="header">
            <tr>
                <th width="145px"></th>
                <th [pSortableColumn]="'FirstName'" >First Name
                   <p-sortIcon [field]="'FirstName'"></p-sortIcon></th>
                    <th [pSortableColumn]="'LastName'">Last Name
                      <p-sortIcon [field]="'LastName'"></p-sortIcon>
                    </th>

                <th >Uploaded docs to approve
                </th>


            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-userToApprove>
            <tr >
                <td>
                  <span class="pointer mr-2" *ngIf="canEdit"   (click)="openDocsToApprove(userToApprove)"><i title="See docs" class="fas fa-edit"></i></span>
                </td>
                <td>
                    <span class="ui-column-title">First Name</span>
                  {{userToApprove.firstName }}
                </td>

                <td>
                  <span class="ui-column-title">Last Name</span>
                {{userToApprove.lastName }}
              </td>
                <td>
                  <span class="ui-column-title">Uploaded docs to approve</span>
                  <div *ngFor="let doc of userToApprove.unApprovedUploadDocs">
                    {{doc.onboarding_UploadDocType}}
                  </div>
                </td>

            </tr>
        </ng-template>
        <ng-template pTemplate="paginatorleft" let-state>
          Showing {{ state.first + 1 }} - {{ (state.first + state.rows) > state.totalRecords ? state.totalRecords : (state.first + state.rows) }} of {{ state.totalRecords }} entries
      </ng-template>
      <ng-template pTemplate="paginatorright">
            <div style="display: flex; align-items: center; gap: 0.5rem;">
                <span style="color: #495057; font-size: 14px; white-space: nowrap;">Rows per page:</span>
                <p-dropdown 
                    [options]="dropdownOptions()" 
                    optionLabel="label" 
                    optionValue="value"
                    [ngModel]="myTable.rows" 
                    (onChange)="myTable.rows = $event.value; myTable.reset()">
                </p-dropdown>
            </div>
      </ng-template>
    </p-table>
  </div>
</form>

<p-confirmDialog></p-confirmDialog>
